angular.module('impactx.rfxsupplier').component('ixRfxSupplierDates', {
        bindings: {
            publicationDate: '<',
            lastAnswerDateTime: '<',
            informationDate: '<',
            minValidDate: '<',
            isClosed: '<',
            trns: '<'
        },
        controller: 'RFXSupplierDatesCtrl',
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-dates.html'
    }
);